import { ReactElement } from 'react';
import styles from './ButtonContainer.module.scss';

export const ButtonContainer = ({ left, right }: { left: ReactElement; right: ReactElement }) => {
  return (
    <div className={styles['button-container']}>
      {left}
      {right}
    </div>
  );
};
